import performRequest from '../../axios';
import GetValidatedTokenData from '../../../utils/helper';
import { getOrgDomain } from '../../../organization';

const BASE_PARAMS = { applicationId: process.env.REACT_APP_APPLICATION_ID };
const data = GetValidatedTokenData();

export const imageAPI = {
  getAllImages: async () => {
    const domain = getOrgDomain();
    let params = { ...BASE_PARAMS };
    if (domain) {
      params = { ...params, organizationDomain: domain };
    }
    return await performRequest('images', 'GET', null, params);
  },

  getImageByName: async (name) => {
    const params = { ...BASE_PARAMS };
    return await performRequest(`images/${name}`, 'GET', null, params);
  },

  addImage: async (name, url, index=-1) => {
    const params = { ...BASE_PARAMS };
    if (data.organizationId) params.organizationId = data.organizationId;

    return await performRequest('images', 'POST', index === -1 ? {name, url} : {name, url, index}, params);
  },

  editImage: async (name, url, index, remove=true) => {
    const params = { ...BASE_PARAMS };
    if (data.organizationId) params.organizationId = data.organizationId;

    return await performRequest(`images/${name}`, 'PATCH', { url, index, remove }, params);
  },

  removeImage: async (name, index) => {
    const params = { ...BASE_PARAMS };
    if (data.organizationId) params.organizationId = data.organizationId;

    return await performRequest(`images/${name}`, 'PATCH', { index, remove: true }, params);
  },

  deleteImage: async (name) => {
    const params = { ...BASE_PARAMS };
    if (data.organizationId) params.organizationId = data.organizationId;

    return await performRequest(`images/${name}`, 'DELETE', null, params);
  },
};
